import { Tooltip } from '@aon/aon-tws-common-ui';
import { ILibraryQuestion as ICommonLibraryQuestion } from '@aon/tws-common-ui-questions/build/lib/models';
import * as React from 'react';
import ContentConstants from '../contentConstants';
import { ICustomQuestion, IExternalAttributeVm } from '../models';

const mappedAttributeFormattedDisplay = (
	isSelected: boolean,
	attributeIsSelected: boolean,
	message: string,
	mappedAttribute?: IExternalAttributeVm,
): IExternalAttributeVm | undefined => {
	if (!isSelected && attributeIsSelected && mappedAttribute !== undefined) {
		return {
			...mappedAttribute,
			displayName: (
				<span>
					{mappedAttribute.displayName}
					<Tooltip id={mappedAttribute.columnName + '-inuse-tooltip'}>
						<p>
							<strong>{ContentConstants.MAPPED_ATTRIBUTE_TOOLTIP_TITLE}</strong>
						</p>
						<p>{message}</p>
					</Tooltip>
				</span>
			),
		};
	}
	return mappedAttribute;
};

const libraryQuestionIsAvailableForSelection = (
	question: ICommonLibraryQuestion,
	selectedAttributes: string[],
	selectedQuestionIds: number[],
	attributeMaps: IExternalAttributeVm[],
): boolean => {
	const { attributeName, isDemographic, questionVariationId } = question;

	const mappedAttribute = attributeMaps.find((attr: IExternalAttributeVm) => attr.attributeName === attributeName);
	if (isDemographic) {
		const isSelected = questionVariationId ? selectedQuestionIds.indexOf(questionVariationId) > -1 : false;
		const attributeIsSelected = mappedAttribute !== undefined && selectedAttributes.indexOf(mappedAttribute.columnName) > -1;

		return !attributeIsSelected || isSelected;
	}
	return true;
};

const customQuestionIsAvailableForSelection = (
	question: ICustomQuestion,
	selectedAttributes: string[],
	selectedQuestionIds: number[],
): boolean => {
	const { externalAttributeColumnName, isDemographic, questionId } = question;

	if (externalAttributeColumnName && isDemographic) {
		const isSelected = selectedQuestionIds.indexOf(questionId) > -1;
		const attributeIsSelected = selectedAttributes.indexOf(externalAttributeColumnName) > -1;
		return !attributeIsSelected || isSelected;
	}
	return true;
};

const getMappedAttributeForLibraryQuestion = (
	question: ICommonLibraryQuestion,
	selectedAttributes: string[],
	selectedQuestionIds: number[],
	attributeMaps: IExternalAttributeVm[],
): IExternalAttributeVm | undefined => {
	const { attributeName, isDemographic, questionVariationId } = question;

	const mappedAttribute = attributeMaps.find((attr: IExternalAttributeVm) => attr.attributeName === attributeName);
	if (mappedAttribute && isDemographic) {
		const isSelected = questionVariationId ? selectedQuestionIds.indexOf(questionVariationId) > -1 : false;
		const attributeIsSelected = selectedAttributes.indexOf(mappedAttribute.columnName) > -1;

		return MappedAttributeHelper.mappedAttributeFormattedDisplay(
			isSelected,
			attributeIsSelected,
			ContentConstants.MAPPED_ATTRIBUTE_IN_USE_BY_CUSTOM_TOOLTIP_BODY,
			mappedAttribute,
		);
	}

	return undefined;
};

const getMappedAttributeForCustomQuestion = (
	question: ICustomQuestion,
	selectedAttributes: string[],
	selectedQuestionIds: number[],
	attributeMaps: IExternalAttributeVm[],
): IExternalAttributeVm | undefined => {
	const { externalAttributeColumnName, questionId, isDemographic } = question;

	const mappedAttribute = attributeMaps.find((attr: IExternalAttributeVm) => attr.columnName === externalAttributeColumnName);
	if (mappedAttribute && isDemographic) {
		const isSelected = selectedQuestionIds.indexOf(questionId) > -1;
		const attributeIsSelected = selectedAttributes.indexOf(mappedAttribute.columnName) > -1;

		return MappedAttributeHelper.mappedAttributeFormattedDisplay(
			isSelected,
			attributeIsSelected,
			ContentConstants.MAPPED_ATTRIBUTE_IN_USE_BY_LIBRARY_TOOLTIP_BODY,
			mappedAttribute,
		);
	}

	return undefined;
};

export const MappedAttributeHelper = {
	mappedAttributeFormattedDisplay,
	getMappedAttributeForLibraryQuestion,
	getMappedAttributeForCustomQuestion,
	customQuestionIsAvailableForSelection,
	libraryQuestionIsAvailableForSelection,
};
